module.exports = __webpack_public_path__ + "img/zgz.0da5c4b6.png";